(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["react"], factory);
	else if(typeof exports === 'object')
		exports["StaticCmsCoreLive"] = factory(require("react"));
	else
		root["StaticCmsCoreLive"] = factory(root["react"]);
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__156__) => {
return 